export default "__VITE_ASSET__c0986e19__"